module.exports = __webpack_public_path__ + "static/media/logo-primeiracruz.7fafb08e.png";